import React, { useEffect, useState } from 'react';
import { CircularProgress, Container } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';

import TableHeader from '../common/TableHeader';
import { ModalAction } from '../common/Modal';
// import { Title } from './style';

import { getCommunicated, getCommunicationById } from '../../actions/Communicated';
import { Text } from '../common/NotificationTable/style';
import { EmailView } from '../ManageCommunicated/style';
import { Noresults } from '../../Layout/style';

const Communicated = () => {
  const dispatch = useDispatch();
  const { communicated, communicatedInfo } = useSelector(({ communicated }) => ({
    communicated: communicated?.communicated || [],
    communicatedInfo: communicated?.communicatedInfo || [],
  }));

  const [modal, setModal] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [title, setTitle] = useState('');
  const [filteredElements, setFilteredElements] = useState('');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    dispatch(getCommunicated());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFormData(communicatedInfo);

    setTimeout(() => {
      setLoading(false);

    }, 2000)
  }, [communicatedInfo]);

  useEffect(() => {

    if (searchString?.length > 0) {
      setFilteredElements(
        communicated.filter((i) => {
          return i.title.toUpperCase().match(searchString.toUpperCase());
        }),
      );
    } else setFilteredElements(communicated);
  }, [communicated, searchString]);

  const handleOpenComm = async ({ id,title }) => {
    setTitle(title)

    try {
      setLoading(true);
      setModal(true);
      dispatch(getCommunicationById(id));
    } finally {

      // setTimeout(() =>{
      //   setFormData(communicatedInfo);

      // },2000)

    }
  };

  const columns = [
    {
      field: 'title',
      width: 520,
      headerName: 'Título',
      renderCell: ({ row }) => <Text>{row?.title}</Text>,
    },
    {
      field: 'date',
      width: 150,
      headerName: 'Data',
      renderCell: ({ row }) => <Text>{row?.createdAt}</Text>,
    },
    // {
    //   field: 'channel',
    //   width: 370,
    //   headerName: 'Canal',
    //   renderCell: ({ row }) => <Text>{row?.channel}</Text>,
    //   width: 250,
    //   headerName: 'Público',
    // },
    {
      field: 'public',
      renderCell: ({ row }) => <Text>{row.public0 ? 'Sim' : 'Não'}</Text>,
      width: 100,
      headerName: 'Público',
    },
    {
      field: 'active',
      renderCell: ({ row }) => <Text>{row.active ? 'Sim' : 'Não'}</Text>,
      width: 100,
      headerName: 'Ativo',
    },
    // {
    //   field: 'actions',
    //   headerName: 'Açoes',
    //   width: 100,
    //   sortable: false,
    //   renderCell: ({ row }) => (
    //     <>
    //       <IconButton onClick={() => handleOpenComm(row.id)}>
    //         <FontAwesomeIcon icon={faEye} />
    //       </IconButton>
    //     </>
    //   ),
    // },
  ];

  return (
    <>
      <Container>
        <TableHeader setSearchString={setSearchString} placeholder="Pesquisar por Nome" />
        <div style={{ height: 500, width: '100%', background: 'white' }}>
          <DataGrid
            className='communicates'
            onCellClick={({ row }) => { handleOpenComm(row) }}
            components={{
              NoRowsOverlay: () => (
                <Noresults>
                  <span>
                    Resultados não encontrado
                  </span>
                </Noresults>
              ),
            }}
            pageSize={5}
            disableSelectionOnClick
            disableColumnMenu
            hideFooterSelectedRowCount
            rows={filteredElements.length ? filteredElements : []}
            columns={columns}
          />
        </div>
      </Container>
      <ModalAction
        title={title}
        open={modal}
        backAction={() => {
          setModal(false);
        }}
      >
        {loading ? (
          <div style={{ textAlign: 'center', margin: '15px' }}>
            <CircularProgress color="primary" />{' '}
          </div>
        ) : (
          <EmailView srcDoc={formData?.emailBody} />
        )}
      </ModalAction>
    </>
  );
};

export default Communicated;
